<app-dialog-header
  [header]="'user.set_password_url.header' | translate"
  iconClass="icon-change-pass-icon"
>
</app-dialog-header>
<app-dialog-content>
  <div class="p-grid">
    <div class="p-col">
      <div class="input-group">
        <pre data-qa="set-password-url-input">{{ url }}</pre>
        <span class="input-group-addon">
          <app-copy-to-clipboard-button [textToCopy]="url"></app-copy-to-clipboard-button>
        </span>
      </div>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <div class="button-container">
    <button
      (click)="close()"
      data-qa="set-password-url-dialog-close-button"
      type="button"
      class="proget-button text-only"
    >
      {{ 'button.close.label' | translate }}
    </button>
  </div>
</div>
